import { isCancelledItem } from 'swag-common/utils/order';
const getRelatedItemsPricing = items => {
  const {
    setupFee,
    setupFeeDeductionDiscount
  } = items[0];
  const filteredItems = items.filter(item => !isCancelledItem(item));
  const total = filteredItems.reduce((price, next) => price + next.price, 0);
  const isRelated = items.length > 1;
  let oldSetupFee = 0;
  if (setupFeeDeductionDiscount) {
    oldSetupFee = setupFeeDeductionDiscount + setupFee;
  }
  return {
    total,
    isRelated,
    setupFee,
    oldSetupFee
  };
};
export default getRelatedItemsPricing;